import {
  Box,
  Button,
  CircularProgress,
  Container,
  Typography,
} from "@mui/material";
import styled from "@emotion/styled";

const Main = styled(Box)`
  height: 100vh;
`;

export default function Error({
  hasLoader,
  customTitle,
  customMessage,
  errorCollection = [],
  textButton,
  linkButton,
}) {
  const tokenButton = () => {
    window.open(
      linkButton,
      "_black"
    );
  };

  return (
    <Container maxWidth="sm">
      <Main
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
        flexDirection={"column"}
      >
        {hasLoader ? (
          <CircularProgress color="primary" />
        ) : (
          <>
            <Typography variant="title" align="center" color="primary">
              {customTitle}
            </Typography>
            <Typography align="center">
              {customMessage ? customMessage : "VERIFIQUE LOS DATOS"}
            </Typography>
            {errorCollection && errorCollection.length > 0 && (
              <Typography align="center" paddingTop={2}>
                {errorCollection[0].message}
              </Typography>
            )}
            { linkButton != "" && (
              <Button
                style={{
                  background: "primary",
                  marginTop: "10px",
                  borderRadius: "10px",
                  width: "auto",
                }}
                variant={"contained"}
                onClick={tokenButton}
              >
                {textButton}
              </Button>
            )}
          </>
        )}
      </Main>
    </Container>
  );
}
